module.exports = __webpack_public_path__ + "img/SER-B-2-IV.91ce30a0.png";